// extracted by mini-css-extract-plugin
export default {"root":"styles_root__vzujH","historyTable":"styles_historyTable__wmNSd","status":"styles_status__nOu08"};